<ng-container *ngFor="let alert of alerts">
    <ngb-alert type="light" [dismissible]="alert.dismissible" (closed)="closeAlert(alert)">
        <aurora-icon *ngIf="alert.icon" icon="error" class="icon-alert"></aurora-icon>
        <div class="message">{{ alert.message }}</div>
        <aurora-link-button 
                *ngIf="alert.action" 
                (click)="performAction(alert)">
            {{alert.action.label}}
        </aurora-link-button>
    </ngb-alert>
</ng-container>